// Removes this origin's service worker and the caches it filled. Used where
// the dashboard must always load the build the server has (inside the Mac
// app, src/main.tsx); best effort, silent when the browser has neither.

export function dropOfflineCopy(): void {
  try {
    void navigator.serviceWorker
      ?.getRegistrations?.()
      .then((registrations) => Promise.all(registrations.map((r) => r.unregister())))
      .catch(() => undefined);
  } catch {
    // no service workers here
  }
  try {
    if (typeof caches !== "undefined") {
      void caches
        .keys()
        .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
        .catch(() => undefined);
    }
  } catch {
    // no Cache Storage here
  }
}
